import { render, staticRenderFns } from "./AccountSettingsPage.vue?vue&type=template&id=0b00a468&scoped=true"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=js"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsPage.vue?vue&type=style&index=0&id=0b00a468&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00a468",
  null
  
)

export default component.exports